import {UserTypeVo} from '../../common/shared/api/nicolas/vo/enums/UserTypeVo.enum';
import {UserType} from '../generated/types';

export function createUserType(userTypeVo?: UserTypeVo): UserType {
  if (!userTypeVo) return UserType.Unknown;
  return map[userTypeVo];
}

const map: {[key in UserTypeVo]: UserType} = {
  [UserTypeVo.Normal]: UserType.Normal,
  [UserTypeVo.BlackList]: UserType.BlackList,
};
